"use client";

import Link from "next/link";
import StripeButton from "@/components/StripeButton";
import { FaPaypal, FaPatreon } from "react-icons/fa6";

const DonPage = () => {
  return (
    <main className="container mx-auto px-4 py-12">
      <h1 className="text-center text-4xl font-bold text-gray-900 dark:text-white">
        Soutenez Les Concernés
      </h1>
      <p className="mt-2 text-center text-gray-600 dark:text-gray-300">
        Aidez-nous à continuer notre travail en contribuant financièrement via
        l'une des options ci-dessous.
      </p>

      {/* 🔹 Paiement par CB avec Stripe */}
      <section className="mt-10 text-center">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
          Faire un don par carte bancaire
        </h2>
        <p className="mt-2 text-gray-600 dark:text-gray-300">
          Paiement sécurisé avec Stripe.
        </p>
        <StripeButton />
      </section>

      {/* 🔹 Section PayPal */}
      <section className="mt-12 text-center">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
          Faire un don avec PayPal
        </h2>
        <p className="mt-2 text-gray-600 dark:text-gray-300">
          Faites un don sécurisé avec PayPal.
        </p>
        <div className="mt-4">
          <Link
            href="https://www.paypal.com/donate?hosted_button_id=VOTRE_ID_PAYPAL"
            target="_blank"
          >
            <button className="rounded-lg bg-blue-600 px-6 py-3 text-white hover:bg-blue-800">
              <FaPaypal className="mr-2 text-2xl" /> Faire un don avec PayPal
            </button>
          </Link>
        </div>
      </section>

      {/* 🔹 Section Tipeee & Patreon */}
      <section className="mt-12 text-center">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
          Soutien participatif
        </h2>
        <p className="mt-2 text-gray-600 dark:text-gray-300">
          Faites un don via Tipeee ou Patreon.
        </p>
        <div className="mt-4 space-x-4">
          <Link href="https://www.tipeee.com/lesconcernes" target="_blank">
            <button className="rounded-lg bg-red-500 px-6 py-3 text-white hover:bg-red-700">
              Tipeee
            </button>
          </Link>
          <Link href="https://www.patreon.com/lesconcernes" target="_blank">
            <button className="rounded-lg bg-orange-600 px-6 py-3 text-white hover:bg-orange-800">
              <FaPatreon className="mr-2 text-2xl" /> Patreon
            </button>
          </Link>
        </div>
      </section>

      {/* 🔹 Virement bancaire */}
      {/* <section className="mt-12 text-center">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Faire un virement bancaire</h2>
        <div className="mt-4 bg-gray-200 dark:bg-gray-700 p-4 rounded-lg">
          <p className="text-gray-900 dark:text-white"><strong>IBAN :</strong> FR76 3000 4000 5000 6000 7000 890</p>
          <p className="text-gray-900 dark:text-white"><strong>BIC :</strong> BNPAFRPPXXX</p>
        </div>
      </section> */}
    </main>
  );
};

export default DonPage;
